import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CurrentVenueHelperService } from "../../../share-modul/services/current-venue-helper/current-venue.helper.service";
import { Subject, takeUntil, Subscription } from 'rxjs';
import { LoginModel } from '../../models/login/login.model';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { UserModel } from "../../models/user/user.model";
import { RoleNameEnum } from "../../../admin-panel/enums/role-name.enum";
import { Router } from "@angular/router";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {


  public unsubscribe: Subject<void> = new Subject<void>();
  public loginModel: LoginModel = new LoginModel();
  public errorModel: { [k: string]: any } = {};
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public venueIdUpdateSubscription: Subscription;
 
  constructor(
    public _router: Router,
    public authenticationService: AuthenticationService,
    public messageService: MessageService,
    public currentVenueHelper: CurrentVenueHelperService,
    private _jwtHelperService: JwtHelperService,
  ) {}

  ngOnInit(): void { 
  }
  public login(model: LoginModel): void {
    this.errorModel = {};

    if (!model.username || model.username.trim() === "") {
      this.errorModel['Username'] = this.requiredFieldErrorMessage;
    }

    if (!model.password || model.password === "") {
      this.errorModel['Password'] = this.requiredFieldErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {
      this.authenticationService.login(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            localStorage.setItem('pos_access_token', response.jwtToken);
            localStorage.setItem('refresh_token', response.refreshToken);
            const decodedToken = this._jwtHelperService.decodeToken(response.jwtToken);
            const loggedInUser = new UserModel(decodedToken.id, decodedToken.rlnm.split(',').map((x: string) => +x));
            this.authenticationService.loginUser.next(loggedInUser);
            if (loggedInUser.roles.includes(RoleNameEnum.PosGeneralManager)) {
              this.authenticationService._isManager$.next(true);
              this._router.navigateByUrl('dashboard');
            } else {
              if (loggedInUser.roles.includes(RoleNameEnum.PosManager)) {
                this.authenticationService._isManager$.next(true);
                this._router.navigate(['dashboard']);
              } else {
                this.authenticationService._isManager$.next(false);
                this._router.navigate(['dashboard']);
              }
            }
          },
          error: errorResponse => {
            if (errorResponse.error.errors && errorResponse.error.errors.Password) {
              errorResponse.error.errors.Password.forEach((error: string) => {
                this.errorModel['Password'] = error;
              });
            }
            if (errorResponse.error.errors && errorResponse.error.errors.Username) {
              errorResponse.error.errors.Username.forEach((error: string) => {
                this.errorModel['Username'] = error;
              });
            }
            if (errorResponse.error && errorResponse.error.Message) {
              this.messageService.add({ severity: 'error', summary: errorResponse.error.Message ,life: 2000 });
            }
            else if (errorResponse.error && !errorResponse.error.errors) {
              this.messageService.add({ severity: 'error', summary: errorResponse.error.title, life: 2000 });
            }
          }
        });
    }
  }
}


